import React from 'react';

type AlertProps = {
  type?: 'error' | 'success' | 'info';
  children: React.ReactNode;
  onClose?: () => void;
};

export const Alert: React.FC<AlertProps> = ({
  type = 'info',
  children,
  onClose,
}) => {
  const colors = {
    error: 'bg-red-100 text-red-800 border-red-300',
    success: 'bg-green-100 text-green-800 border-green-300',
    info: 'bg-blue-100 text-blue-800 border-blue-300',
  };
  return (
    <div
      className={`border-l-4 p-3 mb-2 rounded ${colors[type]}`}
      role={type === 'error' ? 'alert' : 'status'}
      aria-live="polite"
    >
      <div className="flex justify-between items-center">
        <span>{children}</span>
        {onClose && (
          <button
            onClick={onClose}
            aria-label="Dismiss"
            className="ml-2 text-lg font-bold focus:outline-none"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};
